<template>
    <a href="javascript: void(0);"
        :class="[selectedIndicator.idxSqno == boxInfo.idxSqno || selectedIndicator2.idxSqno == boxInfo.idxSqno ? boxClazz+' on' : boxClazz]"
        @click.prevent="selectIndicator(boxInfo, areaNo)">
        <div :class="['maintitle main'+getBoxTitleClazz(boxInfo.idxCateCd)]">
            {{getIndicatorTitle(boxInfo.idxCateCd)}}
        </div>
        <div class="count">
            {{indicatorValue()}}
            <span>{{boxInfo.idxDispUnit}}</span>
        </div>
        <div class="subtitle">
            {{boxInfo.idxDispNm}}
        </div>
    </a>
</template>

<script>

import gripUtil from "@/libs/grip.util";
import {$_WC, $_TYPE} from '@/confs/common.const.js';
import {mapGetters} from "vuex";

export default {
    props: {
        boxInfo: {
            require: true,
        },
        areaNo: {
            require: true,
        },
        boxClazz: {
            require: true,
        },
        isMain : {
            require: false,
        },
        indicatorDataMap: {
            type: Object,
            require: true,
        },
        indicatorDataKdHdngMap: {
            type: Object,
            require: true,
        },
    },
    data() {
        return {
            // 재정 지표 번호
            financeIdxSqnoArr:[141, 163, 183, 201, 202, 203, 204, 205, 206, 207, 208, 209, 209, 210, 241],
            financeCdList : ['410','411','412','415','416','417','418','420','425','430','435','440','450','455','460'],
        }
    },
    computed: {
        ...mapGetters({
            // indicatorIdxList : 'getIndicatorIdxList',
            // indicatorDataKdMap : 'getIndicatorDataKdMap',
            // indicatorDataMap : 'getIndicatorDataMap',
            // indicatorDataKdHdngMap : 'getIndicatorDataKdHdngMap',
            selectedIndicatorCate : 'getSelectedIndicatorCate',
            indicatorCateList : 'getIndicatorCateList',

            indicatorIdxCateMap : 'getIndicatorIdxCateMap',
            selectedIndicator : 'getSelectedIndicator',
            selectedIndicator2: 'getSelectedIndicator2',
            clazzMap: 'getClazzMap',
        }),
    },
    watch: {
    },
    created() {
        this.$eventBus.$on('select-indicator', (initIndicator) => {
            this.selectIndicator(initIndicator);
        });

        this.$eventBus.$on('select-indicator-list', initIndicatorList => {
            this.selectIndicator(initIndicatorList[Number(this.areaNo)-1], this.areaNo);
        });
    },
    methods: {
        getIndicatorTitle(code) {
            let cateMap = gripUtil.toMap(this.indicatorCateList, 'commonCode');
            let title = '';

            if(typeof cateMap[code] !== $_TYPE.UNDEF) {
                let data = cateMap[code][0];
                title = data.localeTitle;
            }

            return title;
        },
        getBoxTitleClazz(code) {
            return this.clazzMap[code];
        },
        indicatorValue() {
            let val = [];
            if(typeof this.indicatorDataMap[this.boxInfo.idxSqno] !== $_TYPE.UNDEF ) {
                // 데이터 리스트
                let dataList = this.indicatorDataMap[this.boxInfo.idxSqno];
                // 지표 계산식
                let idxCalcMtdCd = this.boxInfo.idxCalcMtdCd;
                // 복수항목 처리 방식
                let idxHdngCalcMtdCd = this.boxInfo.idxHdngCalcMtdCd;
                // 표출 항목 리스트
                let idxKdHdngs = this.boxInfo.idxKdHdngs;
                // 컬럼 리스트
                let colList = this.indicatorDataKdHdngMap[this.boxInfo.idxSqno];
                let colMap = gripUtil.toDict(colList, 'dataKdHdngSqno');

                if(this.boxInfo.idxSqno === 162) {
                    dataList = this.setMinwonValue(dataList);
                }

                if(this.boxInfo.idxCateCd == 8) {
                    if(this.boxInfo.idxSqno != 261) {
                        dataList = this.setFinanceList(dataList);
                    }
                    if(this.boxInfo.idxSqno == 261) {
                        dataList = this.setFldCntList(dataList);
                    }
                }

                if(idxHdngCalcMtdCd === 'concatenate') {
                    idxKdHdngs.forEach((kdHdng) =>{
                        if(kdHdng.fltrVal === null || kdHdng.fltrVal === '') {
                            val.push(0);
                        }
                    });
                } else {
                    val[0] = 0;
                }

                // 필터 역할인 필드는 계산 제외.
                idxKdHdngs.forEach((kdHdng) => {

                    if(kdHdng.fltrVal !== null && kdHdng.fltrVal !== '') {
                        let colNm = kdHdng.dataHdngColnm;
                        if(colMap[kdHdng.dataKdHdngSqno].dataDsc === 'code' || colMap[kdHdng.dataKdHdngSqno].dataDsc === 'indicatoritem') {
                            colNm = colNm.replace('val', 'valNm');
                        }
                        dataList = dataList.filter((data) => {
                            if(kdHdng.fltrOprtorCd === 'equal') {
                                return data[colNm].indexOf(kdHdng.fltrVal) > -1;
                            } else if(kdHdng.fltrOprtorCd === 'notequal') {
                                return data[colNm].indexOf(kdHdng.fltrVal) < 0;
                            } else if(kdHdng.fltrOprtorCd === 'startswith') {
                                return data[colNm].startsWith(kdHdng.fltrVal);
                            } else if(kdHdng.fltrOprtorCd === 'endswith') {
                                return data[colNm].endsWith(kdHdng.fltrVal);
                            } else if(kdHdng.fltrOprtorCd === 'like') {
                                return data[colNm].indexOf(kdHdng.fltrVal) > -1;
                            }
                        });
                    }
                });


                if(dataList.length === 0) {
                    return 0;
                }
                if(idxCalcMtdCd === 'sum') {
                    // 합산인 경우
                    dataList.forEach((data) => {
                        let index = 0;
                        idxKdHdngs.forEach((kdHdng) => {
                            if(typeof data[kdHdng.dataHdngColnm] !== 'undefined'
                                && data[kdHdng.dataHdngColnm] !== '-'
                                && (kdHdng.fltrVal === null || kdHdng.fltrVal === '')) {
                                if(idxHdngCalcMtdCd === 'concatenate') {
                                    val[index] += Number(data[kdHdng.dataHdngColnm]);
                                } else {
                                    val[0] += Number(data[kdHdng.dataHdngColnm]);
                                }
                                index++;
                            }
                        });
                    });
                }
                else if(idxCalcMtdCd === 'count') {
                    // 개수인 경우
                    dataList.forEach((data) => {
                        let index = 0;
                        idxKdHdngs.forEach((kdHdng) => {
                            if(typeof data[kdHdng.dataHdngColnm] !== 'undefined'
                                && data[kdHdng.dataHdngColnm] !== '-'
                                && (kdHdng.fltrVal === null || kdHdng.fltrVal === '')) {
                                if(idxHdngCalcMtdCd === 'concatenate') {
                                    val[index] += Number(data[kdHdng.dataHdngColnm]);
                                } else {
                                    val[0] += Number(data[kdHdng.dataHdngColnm]);
                                }
                                index++;
                            }
                        });
                    });
                }
                else if(idxCalcMtdCd === 'avg') {
                    // 평균인 경우
                    let count = 0;
                    dataList.forEach((data) => {
                        let index = 0;
                        idxKdHdngs.forEach((kdHdng) => {
                            if(typeof data[kdHdng.dataHdngColnm] !== 'undefined'
                                && data[kdHdng.dataHdngColnm] !== '-'
                                && (kdHdng.fltrVal === null || kdHdng.fltrVal === '')) {
                                if(idxHdngCalcMtdCd === 'concatenate') {
                                    val[index] += Number(data[kdHdng.dataHdngColnm]);
                                } else {
                                    val[0] += Number(data[kdHdng.dataHdngColnm]);
                                }
                                index++;
                            }
                        });
                        count++;
                    });
                    val.forEach((v, index) => {
                        val[index] = (v / count);
                    });
                }
                 else if(idxCalcMtdCd === 'latest') {
                    // 최종 값의 경우
                    dataList.concat().sort( function(pre, cur){
                        return Number(pre.basdtVal) - Number(cur.basdtVal);
                        // return Number(pre.basdtVal) > Number(cur.basdtVal) ? -1 : Number(pre.basdtVal) < Number(cur.basdtVal) ? 1 : 0;
                    }.bind(this));
                    let data = dataList[0];
                    let index = 0;
                    if(this.boxInfo.idxSqno == 261) {
                        val[0] = dataList.length;
                    } else {
                        idxKdHdngs.forEach((kdHdng, index) => {
                            if(typeof data[kdHdng.dataHdngColnm] !== 'undefined'
                                && data[kdHdng.dataHdngColnm] !== '-'
                                && (kdHdng.fltrVal === null || kdHdng.fltrVal === '')) {
                                if(idxHdngCalcMtdCd === 'concatenate') {
                                    val[index] += Number(data[kdHdng.dataHdngColnm]);
                                } else {
                                    val[0] += Number(data[kdHdng.dataHdngColnm]);
                                }
                                index++;
                            }
                        });
                    }
                }
            }

            if(this.boxInfo.idxCateCd == 8) {
                if(this.boxInfo.idxSqno == 261) {
                    val.forEach((v, index) => {
                        val[index] = v.toLocaleString();
                    });
                } else {
                    val.forEach((v, index) => {
                        val[index] = this.setFinanceValue(v, 6);
                    });
                }
            } else {
                val.forEach((v, index) => {
                    val[index] = v.toLocaleString();
                });
            }

            if(val.length > 1) {
                return val.join(" / ");
            } else {
                return val[0];
            }
        },

        selectIndicator(boxInfo, areaNo, cate) {
            if(typeof boxInfo !== $_TYPE.UNDEF){
                // console.log( boxInfo, areaNo, cate );
                if(typeof areaNo === $_TYPE.UNDEF || Number(areaNo) === 1){
                    this.$store.dispatch("SET_SELECTED_INDICATOR", boxInfo);
                    // this.$store.dispatch('SET_SELECTED_INDICATOR_CATE', areaNo);
                    // this.$store.dispatch("SET_IS_DETAIL", true);
                    if(typeof this.isMain !== $_TYPE.UNDEF && this.isMain) {
                        let idxSqno = boxInfo.idxSqno;
                        let idxCateCd = boxInfo.idxCateCd;
                        location.href = $_WC.cp + 'indicator?idxSqno='+idxSqno+"&cate="+idxCateCd;
                        // location.href = $_WC.cp + 'indicator';
                    }
                } else if(Number(areaNo) === 2) {
                    this.$store.dispatch("SET_SELECTED_INDICATOR2", boxInfo);
                }
            }
        },
        setMinwonValue(dataList) {
            let nowDate = new Date();
            let basdtVal = nowDate.format('yyyyMMdd');
            basdtVal = basdtVal+'0000';
            let list = [];
            list = dataList.filter((d) => {
                if(d.basdtVal >= basdtVal) {
                    return true;
                }
            })
            return list;
        },
        setFinanceList(dataList) {
            let cdList = this.financeCdList;
            let list = [];
            list = dataList.filter((d) => {
                if(!cdList.includes(d.val1)) {
                    return true;
                }
            })
            return list;
        },
        setFinanceValue(amt, length) {
            let unit = 1;
            for(let i = 0; i < length; i++) {
                unit *= 10;
            }
            let val = Math.floor(amt / unit);
            return val.toLocaleString();
        },
        setFldCntList(dataList) {
            let filteredList = this.setFinanceList(dataList);
            let groupMap = {};
            let list = [];
            filteredList.forEach((d) => {
                if(typeof groupMap[d.val19] === $_TYPE.UNDEF) {
                    groupMap[d.val19] = d;
                    list.push(d);
                }
            })
            return list;
        }
    },
}
</script>
<style>
.swiper-wrapper {
    display: flex !important;
}
.swiper-slide {
    padding:0 35px 0 0;
    width:100%;
}

/* .sc04dd_02_box .mainOO {color:#ff4ed3 !important;}
.sc04dd_02_box .mainY {color:#d3cf00 !important;} */

.sc04dd_02_box.on{border:solid 2px #00a0e9;}
.sc04_02_box.on{border:solid 2px #00a0e9;}
/* .sc04dd_02_box .maintitle{font-weight: 600;} */

@media (min-width:769px) and (max-width: 2736px) {
    .main-container .sc04_02_box .subtitle {font-size: 12px;}
}
</style>
